<template>
  <div id="app">
    <div v-show="this.$store.state.DLINE_ENVIRONMENT==1" id="devenvironment_warning" style="position:fixed;z-index:10000;top:0;width:100px;margin-left:-50px;left:50%;background-color:#ffb734;text-align:center;padding:10px;border-radius:0 0 4px 4px;opacity:.5;font-weight:bold;pointer-events:none;">测试环境</div>
    <keep-alive>
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>

    <!-- <a
      :href="this.$store.state.FROM_OPO"
      style="position: fixed; top: 70%; left: 0px; background-color: rgb(0, 129, 231); color: rgb(255, 255, 255); padding: 7px 10px; border-radius: 0px 100px 100px 0px; opacity: 0.9; font-weight: bold; user-select: none; cursor: pointer; z-index: 999999;"
      v-if="this.$store.state.FROM_OPO"
    >返回 O+O</a> -->

    <a
      v-if="!$store.state.browser.giantopoapp && origin_system != 'cloudpos' && origin_type != 'cloudposmobile'"
      class="back_opo"
      :class="{active: backType==0}"
      @click="goto_opo"
    >
      <span v-if="backType">返回 O+O</span>
      <i class="material-icons" v-else>&#xe5cc;</i>
    </a>
    <!--:href="$store.state.externalurl.opo"-->

  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      backType: 1,
      origin_system: 'cloudpos',
      origin_type: 'cloudposmobile',
    };
  },
  methods: {
    goto_opo(){
      const _this = this;
      if( _this.backType ){
        if( _this.$store.state.browser.giantopoapp){
          if( _this.$store.state.browser.ios ){
            window.webkit.messageHandlers.back.postMessage('');
          }else{
            android.back();
          }
        }else{
          location.replace(_this.$store.state.externalurl.opo);
        }
      }else{
        _this.backType = 1;
      }
    },

    scrollToTop() {
  　　const _this = this;

      _this.backType = 0;
    },
    
    // 获取origin_system参数
    getOriginSystem() {
      const _this = this;
      let originSystem = '';
      
      // 1. 先从URL的hash参数中获取
      const hash = window.location.hash;
      if (hash) {
        const hashParams = new URLSearchParams(hash.split('?')[1] || '');
        originSystem = hashParams.get('origin_system') || '';
      }
      
      // 2. 如果hash中没有，从完整URL中查找
      if (!originSystem) {
        const fullUrl = window.location.href;
        const urlMatch = fullUrl.match(/[?&]origin_system=([^&]+)/);
        if (urlMatch) {
          originSystem = urlMatch[1];
        }
      }
      
      // 3. 如果URL中也没有，从sessionStorage获取
      if (!originSystem) {
        originSystem = sessionStorage.getItem('origin_system') || '';
      }
      
      // 4. 如果获取到了，保存到sessionStorage
      if (originSystem) {
        sessionStorage.setItem('origin_system', originSystem);
      }
      
      _this.origin_system = originSystem;
    },
  },
  watch: {
    // 监听路由变化，及时更新origin_system
    '$route'(to, from) {
      this.getOriginSystem();
    }
  },
  created(){
    // 在created阶段就获取，确保组件初始化时就有正确的值
    this.getOriginSystem();
  },
  mounted(){
    const _this = this;
    // 再次获取，确保值是最新的
    _this.getOriginSystem();
    window.addEventListener('scroll', _this.scrollToTop)
  },
}
</script>

<style>
.back_opo {
  position: fixed;
  top: 80%;
  left: 0;
  background-color: #4E66FF;
  color: rgb(255, 255, 255);
  padding: 7px 10px;
  border-radius: 0 100px 100px 0;
  opacity: 0.9;
  font-weight: bold;
  user-select: none;
  cursor: pointer;
  z-index: 999;
}
.back_opo.active {
  padding: 3px 5px;
}
.back_opo .material-icons {
  font-size: 18px;
  line-height: normal;
  padding-top: 4px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue